/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEcommMobileStreamBanner contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum textAlignment {
    left = 'left',
    right = 'right'
}

export interface IEcommMobileStreamBannerConfig extends Msdyn365.IModuleConfig {
    mobilePage: Msdyn365.ILinkData;
    bannerImage?: Msdyn365.IImageData;
    bannerTitle?: string;
    caption?: string;
    textAlignment?: textAlignment;
}

export interface IEcommMobileStreamBannerProps<T> extends Msdyn365.IModule<T> {
    config: IEcommMobileStreamBannerConfig;
}
